export const HOME_SCREEN = "/home"
export const NOT_ENABLED_SCREEN = "/not-enabled"
